import {
  MarketAccessory,
  MarketActivityIndicator,
  MarketRow,
  MarketTooltip,
} from '@market/react';
import React from 'react';

import styles from 'typescript/apps/checkout_v3/components/order_summary/components/item.module.scss';

export type ItemProps = {
  label: string;
  cost: string;
  imgSrc?: string;
  emphasize?: boolean; // used to make bold
  subtext?: string;
  size?: 'small' | 'medium';
  tooltip?: string;
  isLoading?: boolean;
};

export const Item = ({
  label,
  cost,
  imgSrc,
  emphasize = false,
  subtext,
  size,
  tooltip,
  isLoading = false,
}: ItemProps) => {
  return (
    <MarketRow className={styles.itemRow} size={size}>
      {imgSrc && (
        <MarketAccessory size="image" slot="leading-accessory">
          <img alt={label} src={imgSrc} />
        </MarketAccessory>
      )}
      <label slot="label">
        <span className={emphasize ? 'heading-20' : 'semibold-20'}>
          {label}
        </span>
      </label>
      <label slot="side-label">
        {isLoading ? (
          <MarketActivityIndicator size="small" />
        ) : (
          <>
            <span className={emphasize ? 'heading-20' : 'paragraph-20'}>
              {cost}
            </span>
            {tooltip && (
              <MarketTooltip
                popoverPlacement="bottom-end"
                className={styles.tooltip}
              >
                <span slot="content" className="paragraph-20">
                  {tooltip}
                </span>
              </MarketTooltip>
            )}
          </>
        )}
      </label>
      {subtext && <p slot="subtext">{subtext}</p>}
    </MarketRow>
  );
};
